/**
 * RegistrationBelegSelect.tsx - the Beleg picker of the registration decisions and of lifting a policy's
 * exception: the registration's mails (each followed by its stored attachments, api order, newest
 * first), «Weitere laden» while the api has a further page, then the customer's documents.
 */

import { Button } from '../../components/ui/Button';
import type { RegistrationBelege } from './registration-beleg';

export function RegistrationBelegSelect({
  belege,
  value,
  onChange,
  placeholder,
  className = 'rounded border px-2 py-1 text-sm',
}: {
  belege: RegistrationBelege;
  value: string;
  onChange: (id: string) => void;
  placeholder: string;
  className?: string;
}) {
  return (
    <>
      <select className={`${className} max-w-full`} aria-label="Beleg" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{placeholder}</option>
        {belege.mails.length > 0 && (
          <optgroup label="E-Mails">
            {belege.mails.map((o) => (
              <option key={o.id} value={o.id}>
                {o.kind === 'attachment' ? `  ${o.label}` : o.label}
              </option>
            ))}
          </optgroup>
        )}
        {belege.documents.length > 0 && (
          <optgroup label="Dokumente des Kunden">
            {belege.documents.map((o) => (
              <option key={o.id} value={o.id}>
                {o.label}
              </option>
            ))}
          </optgroup>
        )}
      </select>
      {belege.hasMore && (
        <Button size="sm" variant="ghost" disabled={belege.loadingMore} onClick={belege.loadMore}>
          Weitere laden
        </Button>
      )}
    </>
  );
}
